/* eslint-disable react/prop-types */
// @ts-nocheck
import React, { useEffect, useContext, useState } from 'react';
import { connect } from 'react-redux';
import { ServiceContext } from 'contexts/service';
import { Container } from '@material-ui/core';
import { DOCUMENTACAO } from 'constants/common/pageTitles';
import NoResults from 'global/modules/NoResults';
import { sendDocumentationEmail } from 'store/actions/sales';
import { fetchProcessesBySteps, processSearch, clearResponses } from 'store/actions/processes';
import { STEP_ALIGNMENT, STEP_DOCUMENTATION } from 'constants/process';
import { FULFILLED } from 'constants/session';
import { LoadingComponent } from 'global/modules/Loading';
import {
  array, string, oneOfType, number, func,
} from 'prop-types';
import { DEFAULT } from 'constants/common';
import Row from './Row';
import Header from './Header';
import { useStyles } from '../style';
import Dialogs from './modules/Dialogs';
import Menus from './modules/Menus';
import HeaderColumn from './HeaderColumn';
import Pagination from "@material-ui/lab/Pagination";

function Documentacao({
  documentationReq,
  status,
  update,
  setUpdate,
  allProcessesReq,
  fetch,
  totalPages
}) {
  const classes = useStyles();
  const serviceContext = useContext(ServiceContext);
  const { currentClient, currentProcess } = serviceContext;
  const [documentation, setDocumentation] = useState(documentationReq);
  const [allProcesses, setAllProcesses] = useState(allProcessesReq);
  const [requesting, setRequesting] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    if (status === FULFILLED && requesting) {
      setRequesting(false);
    }
    setDocumentation([...documentationReq]);
    setAllProcesses([...allProcessesReq]);
  }, [status, allProcessesReq, documentationReq, requesting]);

  useEffect(() => {
    if (!requesting) {
      setRequesting(true);
      fetch([STEP_ALIGNMENT, STEP_DOCUMENTATION]);
      serviceContext.setSearchValue('');
      serviceContext.setSortItems(false);
    }
    // eslint-disable-next-line
  }, [update]);

  const handleCurrentPage = (e, page) => {
    setCurrentPage(page);
    fetch([STEP_ALIGNMENT, STEP_DOCUMENTATION], page);
  }

  return (
    <>
      <Header
        responseSize={allProcesses.length}
        filteredSize={documentation.length}
        singleResult={documentation.length === 1}
        pageTitle={DOCUMENTACAO}
      />
      <Container maxWidth="xl">
        <Menus />
        <HeaderColumn filteredSize={documentation.length} />
        {documentation
          && status === FULFILLED
          && documentation.length === 0
          ? (
            <NoResults
              message="Nenhum processo encontrado"
            />
          ) : documentation.map((process) => (
            <Row key={`process${process.id}`} singleResult={documentation.length === 1} item={process} />
          ))}
        {status !== FULFILLED && documentationReq.length === 0 && (
          <LoadingComponent />
        )}
        {currentProcess !== null
          && Object.keys(currentClient).length > 0
          && (
            <Dialogs
              context={serviceContext}
              classes={classes}
              setUpdate={setUpdate}
              update={update}
            />
          )}
        <Pagination count={totalPages} page={currentPage} onChange={handleCurrentPage} />
      </Container>
    </>
  );
}

Documentacao.propTypes = {
  documentationReq: array.isRequired,
  status: string,
  update: oneOfType([string, number]),
  setUpdate: func,
  allProcessesReq: array.isRequired,
};

Documentacao.defaultProps = {
  status: DEFAULT,
  update: '',
  setUpdate: () => { },
};

const mapToStateToProps = (state) => ({
  documentationReq: state.processes.collection,
  allProcessesReq: state.processes.allProcesses,
  status: state.processes.status,
  totalPages: state.processes.totalPages,
});

const actions = {
  fetch: fetchProcessesBySteps,
  sendDocumentationEmail,
  processSearch,
  clearResponses,
};

export default connect(mapToStateToProps, actions)(Documentacao);
